import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import { Grid, Typography } from "@mui/material";
import Logo from "../componentes/Logo";
import {
    GooglePlayButton,
    AppGalleryButton,
    ButtonsContainer,
    AppStoreButton,
} from "react-mobile-app-button";
import Formulario from "../componentes/Formulario";
import { getSorteoActivo } from "../servicios/axios.service";
const Home = () => {
    const [tieneSorteo, setTieneSorteo] = useState(false);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        let activo = true;

        const cargarSorteo = async () => {
            try {
                const resultado = await getSorteoActivo();
                if (!activo) {
                    return;
                }
                setTieneSorteo(Boolean(resultado));
            } catch (error) {
                if (!activo) {
                    return;
                }
                setTieneSorteo(false);
            } finally {
                if (activo) {
                    setCargando(false);
                }
            }
        };

        cargarSorteo();

        return () => {
            activo = false;
        };
    }, []);

    const APKUrl =
        "https://play.google.com/store/apps/details?id=com.appdiferente2024&hl=es_419";
    const IOSUrl =
        "https://apps.apple.com/es/app/diferente-gourmet/id6499525890";
    return (
        <Grid
            container
            direction="column"
            alignItems="center"
            spacing={2}
            sx={{
                bgcolor: "#ffe6f4",
                maxWidth: "100%",
                minHeight: "100vh",
                py: 4,
                px: 2,
            }}
        >
            <Grid item sx={{ width: "70%" }}>
                <Logo />
            </Grid>
            <Grid
                item
                sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                {!cargando &&
                    (tieneSorteo ? (
                        <Formulario />
                    ) : (
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            En estos momentos no hay sorteos activos
                        </Typography>
                    ))}
            </Grid>
        </Grid>
    );
};

export default Home;
